import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import TitlePage from '../../../components/general/TitlePage/TitlePage';
import TitleSectionComponent from '../../../components/intern/TitleSectionComponent/TitleSectionComponent';
import CardToolList from '../../../components/extern/CardTool/utils/CardToolList';
import Button from '../../../components/general/Button/Button';
import Alert from '../../../components/intern/Alert/Alert';
import TextareaComponent from '../../../components/general/Textarea/Textarea';

const Home = () => {
    const MAX_CHARACTERS = 500;
    const [message, setMessage] = useState('');
    const [alertType, setAlertType] = useState('');
    const [isAlertVisible, setIsAlertVisible] = useState(false);
    const [error, setError] = useState('');

    // Limita texto na digitação
    const handleMessageChange = (event) => {
        const text = event.target.value.slice(0, MAX_CHARACTERS);
        setMessage(text);
        setError('');
    };

    // Controla auto-hide por efeito
    useEffect(() => {
        if (!isAlertVisible) return;
        const t = setTimeout(() => setIsAlertVisible(false), 5000);
        return () => clearTimeout(t);
    }, [isAlertVisible]);

    const handleSubmit = (event) => {
        event.preventDefault();

        if (message.trim() === '') {
            setAlertType('info');
            setIsAlertVisible(true);
            return;
        }

        // Enviar para API quando estiver pronto
        setAlertType('envio');
        setIsAlertVisible(true);
        setMessage('');
    };


    return (
        <section className="container-extern content-with-sidebar">
            <TitlePage
                title="Olá, seja bem-vindo!"
                subtitle="Conte com nosso suporte para otimizar suas análises e gestão de relatórios."
            />

            <Helmet>
                <title>Home</title>
            </Helmet>

            <TitleSectionComponent>Atalhos Rápidos:</TitleSectionComponent>

            <CardToolList />

            <TitleSectionComponent>Envie sua mensagem ao suporte:</TitleSectionComponent>

            <form onSubmit={handleSubmit} className="form-messagetextarea" noValidate>
                <div className="textarea-wrapper">
                    <TextareaComponent
                        label=""
                        name="mensagem"
                        value={message}
                        onChange={handleMessageChange}
                        placeholder="Descreva seu problema ou dúvida ou sugestão aqui... "
                        rows={5}
                        maxLength={500}
                        error={error}
                    />
                    <small>{MAX_CHARACTERS - message.length} caracteres restantes</small>
                </div>

                <div className="section-btn-page">
                    <Button type="submit" variant="send" className="btn-primary" disabled={!!error}
                        aria-busy={alertType === 'envio' && isAlertVisible} >
                        Enviar Mensagem
                    </Button>
                </div>
            </form>


            {isAlertVisible && (
                <Alert
                    type={alertType}
                    onClose={() => setIsAlertVisible(false)}
                />
            )}
        </section>
    );
};

export default Home;
